// import external dependencies
import 'jquery';
import 'slick-carousel/slick/slick';
import Swal from 'sweetalert2';

// Import everything from autoload
import './autoload/_bootstrap.js'

let lightGallery = null;
// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import AOS from 'aos';
import 'lightgallery.js';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
});

AOS.init();

// Load Events
jQuery(document).ready(() => routes.loadEvents());

$('.banner-carousel-x').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    speed: 900,
    dots: false,
    infinite: true,
});

$('.banner-carousel-y').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 900,
    vertical: true,
    arrows: false,
    asNavFor: '.banner-carousel-x',
    dots: false,
    infinite: true,
});

$('.testimonial-carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    speed: 900,
    dots: false,
    infinite: true,
});


$('.standard-carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    speed: 900,
    dots: true,
    infinite: true,
});


$('.brands-carousel').slick({
    arrows: false,
    speed: 900,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    mobileFirst: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
        {
            breakpoint: 1050,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
            },
        },
        {
            breakpoint: 850,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            },
        },
        {
            breakpoint: 700,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            },
        },
    ],
});


$(window).on('scroll', function () {

    if (window.scrollY > 20 && !$('.fixed-header').hasClass('scrolled')) {
        $('.fixed-header').addClass('scrolled');
    } else if (window.scrollY <= 20 && $('.fixed-header').hasClass('scrolled')) {
        $('.fixed-header').removeClass('scrolled');
    }

    if (window.innerWidth < 768)
        return;

    $('.banner-content').css({
        'transform': 'translate3D(0, ' + (window.scrollY * -0.3) + 'px, 0)',
    });

    handleFloatyText();
});

function handleFloatyText() {
    // $('.floaty-text').each(function() {
    //     let elmTop = $(this)[0].getBoundingClientRect().top + window.scrollY;
    //     if(Math.abs(elmTop - window.scrollY) > 1000)
    //         return;
    //     let offset = (window.scrollY - elmTop) / 10;
    //     if(typeof $(this).data('reverse') !== 'undefined') {
    //         console.log('reversed');
    //         offset *= -2;
    //     }
    //     $(this).css({
    //         'transform': 'translate3D(' + offset + 'px, 0, 0)',
    //     });
    // });
}

if (window.innerWidth > 767)
    handleFloatyText();

let spinner_carousel_active = 1;

function initiateSpinnerCarouselHandlers() {
    let spinner_width = $('.spinner-carousel').width();
    $('.spinner-carousel img').css('width', spinner_width);
    $('.spinner-carousel img').css('height', spinner_width * 0.8);
    $('.spinner-carousel').closest('div').css('height', spinner_width * 0.8);
    $('.spinner-carousel-left, .spinner-carousel-right').css('top', (spinner_width * 0.4) - 20);

    $('.spinner-carousel-left').click(function () {
        spinner_carousel_active += 1;
        refreshSpinnerCarousel();
        //initiateSpinnerCarouselHandlers();
    });
    $('.spinner-carousel-right').click(function () {
        spinner_carousel_active -= 1;
        refreshSpinnerCarousel();
        //initiateSpinnerCarouselHandlers();
    });
}

setTimeout(function () {
    refreshSpinnerCarousel();
    initiateSpinnerCarouselHandlers();
}, 500)


function refreshSpinnerCarousel() {
    $('.spinner-carousel img').removeClass('active').removeClass('to-left').removeClass('to-right');
    let spinner_carousel_count = $('.spinner-carousel img').size();
    $('.spinner-carousel img').eq((spinner_carousel_active - 1) % spinner_carousel_count).addClass('to-left')
    $('.spinner-carousel img').eq((spinner_carousel_active) % spinner_carousel_count).addClass('active')
    $('.spinner-carousel img').eq((spinner_carousel_active + 1) % spinner_carousel_count).addClass('to-right')
}


/*BOOTSTRAP DROPDOWN ON HOVER*/
const $dropdown = $('.dropdown');
const $dropdownToggle = $('.dropdown-toggle');
const $dropdownMenu = $('.dropdown-menu');
const showClass = 'show';

$(window).on('load resize', function () {
    if (this.matchMedia('(min-width: 768px)').matches) {
        $dropdown.hover(
            function () {
                const $this = $(this);
                $this.addClass(showClass);
                $this.find($dropdownToggle).attr('aria-expanded', 'true');
                $this.find($dropdownMenu).addClass(showClass);
            },
            function () {
                const $this = $(this);
                $this.removeClass(showClass);
                $this.find($dropdownToggle).attr('aria-expanded', 'false');
                $this.find($dropdownMenu).removeClass(showClass);
            }
        );
    } else {
        $dropdown.off('mouseenter mouseleave');
    }
});
$('.show-more-partners').click(function () {
    $('.show-more-partners').slideUp();
    $('.hidden-partners').slideDown('slow');
});

$('.gallery .categories .gallery-item').click(function () {
    $('.categories .gallery-item').hide(200);
    $('.back-to-categories').show();
    let category = $(this).data('category');
    $('.items .gallery-item').each(function () {
        if ($(this).data('category') === category) {
            $(this).show(200);
        }
    })
});
$('.back-to-categories').click(function () {
    $('.items .gallery-item').hide(200);
    $('.categories .gallery-item').show(200);
    $(this).hide();
});
//$('.gallery').css('min-height', $('.gallery').height());

$('.open-video').click(function () {
    var video_url = $(this).data('url');
    var embed_url = video_url.replace(/(?:https:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g, '<iframe width="100%" height="470" src="https://www.youtube.com/embed/$1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');

    Swal.fire({
        html: embed_url,
        showConfirmButton: false,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Close',
        width: '75%',
    });
});

$(function () {
    if (!lightGallery) {
        setTimeout(function () {
            $('.gallery .items .group').each(function () {
                window.lightGallery($(this)[0]);
            });
        }, 1000);
    }


})

/* eslint-disable */
CookieConsent.run( {
    guiOptions: {
        consentModal: {
            layout: "box inline",
            position: "bottom right",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true
        },
        functional: {},
        analytics: {},
        marketing: {}
    },
    language: {
        default: "en",
        autoDetect: "browser",
        translations: {
            en: {
                consentModal: {
                    title: "Cookies",
                    description: "We use cookies to help deliver a better experience to you. You can read our policy here: <a href=\"/cookie-policy\" target=\"_blank\">Learn more</a>",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    showPreferencesBtn: "Manage preferences",
                },
                preferencesModal: {
                    title: "Cookies",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    savePreferencesBtn: "Save preferences",
                    closeIconLabel: "Close modal",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            description: "We use cookies to help deliver a better experience to you. You can read our policy here: <a href=\"/cookie-policy\" target='_blank'>Learn more</a>"
                        },
                        {
                            title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                            description: "These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: 'Functional',
                            description: 'Functional cookies help perform certain functionalities like sharing the content of the website on social media platforms, collecting feedback, and other third-party features.',
                            linkedCategory: 'functional',
                        },
                        {
                            title: "Analytics Cookies",
                            description: "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Marketing Cookies",
                            description: "These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.",
                            linkedCategory: "marketing"
                        }
                    ]
                }
            }
        }
    }
} )
const updateGtagConsent = () => {
    console.log('consent update')
    gtag('consent', 'update', {
        'ad_storage': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        'ad_user_data': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        'ad_personalization': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        'functionality_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        'personalization_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        'security_storage': 'granted', //necessary
    });
};
window.addEventListener('cc:onConsent', () => {
    updateGtagConsent();
});
window.addEventListener('cc:onChange', () => {
    updateGtagConsent();
});



// WEBPACK FOOTER //
// ./scripts/main.js